/**
 * Warms browser cache for main product gallery images (main-product section only).
 * Runs after first hero image loads or on idle — does not block initial render.
 */
(function () {
  var VIDEO_RE = /\.(mp4|webm|m3u8|mov)(\?|#|$)/i;

  function isLikelyVideoUrl(url) {
    return VIDEO_RE.test(url || '');
  }

  function preloadGalleryImages(root) {
    if (!root) return;

    var seen = new Set();

    function urlsAdd(raw) {
      if (!raw || typeof raw !== 'string') return;
      var abs;
      try {
        abs = new URL(raw, window.location.href).href;
      } catch (e) {
        return;
      }
      if (seen.has(abs)) return;
      if (isLikelyVideoUrl(abs)) return;
      seen.add(abs);
    }

    function collectSrcsetUrls(attr) {
      if (!attr || typeof attr !== 'string') return;
      attr.split(',').forEach(function (part) {
        var url = part.trim().split(/\s+/)[0];
        if (url) urlsAdd(url);
      });
    }

    root.querySelectorAll('[id^="Slider-Gallery"] img').forEach(function (img) {
      if (img.currentSrc) urlsAdd(img.currentSrc);
      if (img.src) urlsAdd(img.src);

      collectSrcsetUrls(img.getAttribute('srcset'));
      collectSrcsetUrls(img.getAttribute('data-srcset'));

      var dataSrc = img.getAttribute('data-src');
      if (dataSrc) urlsAdd(dataSrc);
    });

    seen.forEach(function (url) {
      var preloadImg = new Image();
      preloadImg.decoding = 'async';
      preloadImg.src = url;
    });
  }

  function runPreload() {
    var section = document.querySelector('section[id^="MainProduct-"]');
    if (!section) return;
    preloadGalleryImages(section);
  }

  function scheduleIdle() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(runPreload, { timeout: 1500 });
    } else {
      setTimeout(runPreload, 800);
    }
  }

  function scheduleProductGalleryPreload() {
    var section = document.querySelector('section[id^="MainProduct-"]');
    if (!section) return;

    var firstImg = section.querySelector('[id^="Slider-Gallery"] img');
    var started = false;

    function startOnce() {
      if (started) return;
      started = true;
      scheduleIdle();
    }

    if (firstImg && !firstImg.complete) {
      firstImg.addEventListener('load', startOnce, { once: true });
      firstImg.addEventListener('error', startOnce, { once: true });
      setTimeout(startOnce, 4000);
    } else {
      startOnce();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleProductGalleryPreload);
  } else {
    scheduleProductGalleryPreload();
  }
})();
